import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import rectangle from '../../assets/img/rect-road.svg';
import car from '../../assets/img/car.png';
import road from '../../assets/img/road.svg';
import RouterPaths from '../../constants/RouterPaths';
import { scrollIntoView } from '../../common/helpers/scrollIntoView';
import rectangleBuyCars from '../../assets/img/rect-buy.svg';
import ornamentBuy from '../../assets/img/ornament-buy.svg';
import ornamentSell from '../../assets/img/ornament-sell.svg';
import addIcon from '../../assets/img/icons/add_circle.svg';

function HeroSection() {
  const navigate = useNavigate();

  const handleNavClick = (id) => {
    scrollIntoView(id, navigate);
  };
  return (
    <section className="hero-section">
      <div className="hero-section-image">
        <img src={rectangle} alt="Rectangle" className="hero-section-image__rect" />
        <img src={rectangle} alt="Rectangle" className="hero-section-image__rect" />
        <img src={rectangle} alt="Rectangle" className="hero-section-image__rect" />
        <img src={rectangle} alt="Rectangle" className="hero-section-image__rect" />
        <img src={rectangleBuyCars} alt="Rectangle" className="hero-section-image__rect" />
        <img src={ornamentSell} alt="Arrows" className="hero-section-image__ornament" />
        <img src={ornamentBuy} alt="Arrows" className="hero-section-image__ornament" />
      </div>
      <div className="hero-section__header">
        <h2 className="hero-section__header-title">
          <span>
            <span>Unlock</span> the stock
          </span>
          <span>
            <span>for your</span>
            <div>business</div>
          </span>
        </h2>
        <p className="hero-section__header-subtitle">
          BUY AND SELL FRANCHISED STOCK WITH <span>EASE. NO FUSS, NO NONSENSE.</span>
        </p>
        <div className="hero-section__header-buttons">
          <NavLink
            to={RouterPaths.REGISTER}
            className="common-button primary-button hero-section__header-button"
          >
            Sign up
          </NavLink>
          <NavLink
            to={RouterPaths.LOGIN}
            className="common-button outline-primary hero-section__header-button"
          >
            Log In
          </NavLink>
        </div>
        <div className="hero-section-image-car-and-road">
          <img src={road} alt="Road" />
        </div>
        <img src={car} alt="Car" className="car-img" />
      </div>
      <div className="hero-section__transactions">
        <div className="hero-section__transaction">
          <h3 className="hero-section__transaction-title">Sell cars</h3>
          <p className="hero-section__transaction-subtitle">
            Sell cars with ease. At a one-off £45/per listing.
          </p>
          <NavLink
            to="#sell-car"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('sell-car');
            }}
            className="hero-section__transaction-button common-button red-button w-100"
          >
            Sell cars
            <img src={addIcon} alt="Plus icon" />
          </NavLink>
        </div>
        <div className="hero-section__transaction">
          <h3 className="hero-section__transaction-title">Buy cars</h3>
          <p className="hero-section__transaction-subtitle">
            Access consistent franchised stock with flexible funding.
          </p>
          <NavLink
            className="hero-section__transaction-button common-button red-button w-100"
            to="#buy-car"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick('buy-car');
            }}
          >
            Buy cars
            <img src={addIcon} alt="Plus icon" />
          </NavLink>
        </div>
      </div>
    </section>
  );
}

export default HeroSection;
